module.exports = __webpack_public_path__ + "img/delivery-4.806f27b.svg";